import { API_ENDPOINTS, apiService } from "../api";
import type {
  CreateEmbedTokenResponse,
  EmbedStoryResponse,
} from "./embedApi.types";

export const fetchEmbedStory = async (
  token: string,
): Promise<EmbedStoryResponse> =>
  apiService.get<EmbedStoryResponse>(API_ENDPOINTS.embed.story(token));

/** `preview` mints a 10-minute owner-only token that leaves the link's access untouched. */
export const createEmbedToken = async (
  storyId: string,
  ttlHours?: number,
  preview = false,
): Promise<CreateEmbedTokenResponse> =>
  apiService.post<CreateEmbedTokenResponse>(API_ENDPOINTS.embed.createToken(storyId), {
    ...(ttlHours !== undefined ? { ttl_hours: ttlHours } : {}),
    ...(preview ? { preview: true } : {}),
  });
